module.exports = __webpack_public_path__ + "img/bg-img-news-and-announcements-mobile.b0b84db5.png";